import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AllPaymentProfiles,
  ProfileStatuses
} from '../../models/all-payment-profiles.model';
import { EngagementSearchAndFilterInput } from '../../models/engagement-search-and-filter-input.model';
import { PagedResult } from '../../models/page-result.model';
import { PaymentProfileCount } from '../../models/payment-profile-count.model';
import { SettingsService } from '../common/settings.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentProfilesServices {
  constructor(
    public http: HttpClient,
    public settings: SettingsService
  ) {}

  getAllprofilesdetails(
    inputdata: EngagementSearchAndFilterInput
  ): Observable<PagedResult<AllPaymentProfiles>> {
    return this.http.post<PagedResult<AllPaymentProfiles>>(
      this.settings.baseUrl +
        'api/AllPaymentProfiles/GetAllPaymentProfilesDetails',
      inputdata
    );
  }

  getProfileStatuses(): Observable<ProfileStatuses[]> {
    return this.http.get<ProfileStatuses[]>(
      this.settings.baseUrl + 'api/AllPaymentProfiles/GetPaymentProfileStatuses'
    );
  }

  updateProfileStatus(requestData: any) {
    return this.http.post<boolean>(
      this.settings.baseUrl +
        'api/AllPaymentProfiles/UpdatePaymentProfileStatus',
      requestData
    );
  }

  getExportData() {
    return this.http.get<ProfileStatuses[]>(
      this.settings.baseUrl +
        'api/AllPaymentProfiles/GetPaymentProfilesExportData'
    );
  }

  getPaymentProfileCount(): Observable<PaymentProfileCount> {
    return this.http.get<PaymentProfileCount>(
      `${this.settings.baseUrl}api/AllPaymentProfiles/GetPaymentProfileCount`
    );
  }

  downloadmprDocument() {
    return this.http.get(
      this.settings.baseUrl + 'api/PaymetProfileExport/ExportToMPR',
      { observe: 'response', responseType: 'blob' }
    );
  }
}
